import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; 
import { Rooms } from "../../../Assets/Rooms"; 

import { PiBathtubLight } from "react-icons/pi";
import { TbBed } from "react-icons/tb";
import PgHstlFilter from "./PgHstlFilter";

function Filterate_room() {
  const [room, setRoom] = useState([]);
  const [filteredRooms, setFilteredRooms] = useState([]);
  const [genderFilter, setGenderFilter] = useState(""); // State to hold the selected gender filter

  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      easing: "ease-in-out", // Animation easing
      once: false,
      offset: 100,  // Trigger when the element is 100px from the viewport
  delay: 200, // Trigger animation only once
    });
  }, []);

  useEffect(() => {
    setRoom(Rooms); // Initialize with all rooms
  }, []);

  useEffect(() => {
    if (genderFilter === "") {
      setFilteredRooms(room);
    } else {
      const filtered = room.filter((r) => r.gender === genderFilter);
      setFilteredRooms(filtered);
    }
  }, [genderFilter, room]);

  const handleGenderChange = (selectedGender) => {
    setGenderFilter(selectedGender);
  };

  return (
    <div>
      <PgHstlFilter onGenderChange={handleGenderChange} />

      <div className="overflow-x-hidden ">
        {filteredRooms.length > 0 ? (
          filteredRooms.map((i) => (
            <div
              className="flex flex-col w-full my-6 px-4 lg:px-11 gap-6 lg:flex-row"
              key={i.name}
              data-aos="zoom-in-right" // AOS animation
            >
              <img
                src={i.image}
                alt=""
                data-aos="flip-left"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="2000"
                className="h-[200px] md:h-[300px] w-full lg:w-[40vw] rounded-lg object-cover"
              />
              <div className="flex flex-col justify-around w-full lg:w-[50vw] pr-0 lg:pr-0 px-3">
                <div className="flex flex-row justify-between items-start lg:items-center gap-4">
                  <div>
                    <h1 className="text-xl lg:text-2xl">{i.name}</h1>
                    <p className="text-[16px] lg:text-md text-[#696969]">
                      {i.location}
                    </p>
                  </div>
                  <div className="flex justify-center items-center">
                    <div className="md:h-[40px] h-[35px] w-auto lg:w-[140px] flex justify-center items-center bg-[#ECBEB6] rounded-xl px-3">
                      {i.logo}
                      <p className="text-[14px] lg:xl">{i.gender}</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex justify-start items-center text-[16px] lg:text-xl text-[#00C5C8] gap-3 pt-2">
                    <PiBathtubLight />
                    <p>{i.type}</p>
                  </div>
                  <div className="flex flex-wrap gap-3 pt-3">
                    <button className="flex justify-center items-center h-[30px] w-auto lg:w-[105px] bg-[#EEEEEE] rounded-xl gap-2 px-4">
                      <TbBed className="h-[20px] lg:h-[30px] w-[18px] text-[#929292]" />
                      <p className="text-[14px] lg:text-[15px] text-[#929292]">
                        Single
                      </p>
                    </button>
                    <button className="flex justify-center items-center h-[30px] w-auto lg:w-[103px] bg-[#EEEEEE] rounded-xl gap-2 px-2">
                      <TbBed className="h-[20px] lg:h-[30px] w-[18px] text-[#929292]" />
                      <p className="text-[14px] lg:text-[15px] text-[#929292]">
                        Double
                      </p>
                    </button>
                    <button className="flex justify-center items-center h-[30px] w-auto lg:w-[103px] bg-[#EEEEEE] rounded-xl gap-2 px-4">
                      <TbBed className="h-[20px] lg:h-[30px] w-[18px] text-[rgb(146,146,146)]" />
                      <p className="text-[14px] lg:text-[15px] text-[#929292]">
                        Triple
                      </p>
                    </button>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row md:justify-between items-start md:items-center gap-4 lg:gap-6 pt-4 ">
                  <div>
                    <p className="text-[#A8A8A8] text-[16px] lg:text-xl">
                      Starts from
                    </p>
                    <p className="text-[20px] lg:text-2xl">{i.price}</p>
                  </div>
                  
                 <div className="flex justify-center items-center gap-2 sm:gap-6 lg:gap-3 lg:mt-2 mt-0 md:flex-row flex-col w-full sm:w-auto">
                  <button className="h-[40px] md:h-[40px] lg:h-[45px] w-full lg:w-[170px] md:w-[210px] border-[2px] border-[#235784] text-[#235784] rounded-lg">
                    Request a Call back
                  </button>
                  <button className="h-[40px] md:h-[40px] lg:h-[45px] w-full lg:w-[170px] md:w-[210px]  bg-[#235784] text-white rounded-lg">
                    Schedule a visit
                  </button>
                  </div>
                  
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No rooms available for the selected gender filter.</p>
        )}
      </div>
    </div>
  );
}

export default Filterate_room;
